import React from "react";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { GearLoader } from "../../../components/Loaders/new/GearLoader/GearLoader";
import { setError } from "../../../redux/actions/app";
import { tt } from "../../../utils/i18n/i18n";
import { downloadBill } from "../api";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import BillJavaScriptDTO from "@tootsweet/model/datatransfer/BillDTO";

interface PropsT {
  bill: BillJavaScriptDTO;
  loading?: boolean;
}

export const Download = (props: PropsT) => {
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const {
    mutate: downloadBillMutate,
    isLoading: downloadBillLoad,
    error: downloadBillErr
  } = useMutation(downloadBill);

  const onDownloadBill = () => {
    downloadBillMutate({
      billId: props.bill._id,
      billNumber: props.bill.number,
      monthAndYear: props.bill.monthAndYear,
      token: accountToDisplay?.token
    });
  };

  if (downloadBillErr) {
    dispatch(setError(tt("api_error")));
  }

  return (
    <div className="bills-download">
      {downloadBillLoad ? (
        <GearLoader />
      ) : (
        <i
          className="fas fa-download"
          style={{ cursor: "pointer" }}
          onClick={onDownloadBill}
        />
      )}
    </div>
  );
};
